import script from "./FinishView.vue?vue&type=script&setup=true&lang=js"
export * from "./FinishView.vue?vue&type=script&setup=true&lang=js"

import "./FinishView.vue?vue&type=style&index=0&id=00c5a6c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00c5a6c2"]])

export default __exports__